import { Environment } from '@coolblue-development/constants';

export enum ExampleMicrofrontendTest {
  CONTROL = '5ebdd53f-99f5-419c-a869-a379a0b534b9',
  VARIATION_A = '7d62d111-f3f5-4157-886f-e35eb16286a4'
}

const sinterklaasEnabledVariationIds: Record<string, string> = {
  [Environment.DEVELOPMENT]: 'bc293303-9b7e-4ad2-85c0-792fe872dce0',
  [Environment.TESTING]: 'bc293303-9b7e-4ad2-85c0-792fe872dce0',
  [Environment.ACCEPTANCE]: 'ca17c518-486c-42de-8152-b4f366138cc6',
  [Environment.PRODUCTION]: '462fc49a-7d5c-4f6d-a23a-97fb842652ef'
};

export const getSinterklaasVariationId = () => {
  return sinterklaasEnabledVariationIds[process.env.ENVIRONMENT || Environment.TESTING];
};

export enum UpsellAddPayPalPartialPaymentToAppleProductPagesInGermany {
  CONTROL = '3096f1a0-3062-49b2-a3a7-d245a5f67602',
  PAYPAL_SMALL_LOGO = '69560250-a00b-4386-ae33-162b2a40b98f',
  PAYPAL_FULL_LOGO = 'bc881ac3-2419-4671-b987-154570184741',
  PAYPAL_BLACK_AND_WHITE_LOGO = '4b5de915-2267-4257-b89a-7d10e29cea66'
}

export enum UpsellAddOderBlockSummaryToMobile {
  CONTROL = '11be2dbd-a93f-4bc6-b7ef-b5df18f72b71',
  ADD_MOBILE_ORDER_BLOCK_SUMMARY = '6864f50f-2478-4e13-86e9-0dd8577766b4'
}

const salesAdviceGeneratedProductContentVariationIds: Record<string, Record<string, string>> = {
  [Environment.TESTING]: {
    GENERATED: '44d49ebb-c96c-4caf-8e97-c4074abe4af5',
    CONTROL: '6eaf855c-bf5f-4630-b047-70d17269dd45'
  },
  [Environment.DEVELOPMENT]: {
    GENERATED: '44d49ebb-c96c-4caf-8e97-c4074abe4af5',
    CONTROL: '6eaf855c-bf5f-4630-b047-70d17269dd45'
  },
  [Environment.ACCEPTANCE]: {
    GENERATED: 'b9012605-8a94-4ace-ac5d-5d4a28c2ef7b',
    CONTROL: '72112ea1-f01c-4680-bfef-1d77af0ada49'
  },
  [Environment.PRODUCTION]: {
    GENERATED: '3f0a6c9f-740a-4bbe-9bcf-367835144b20',
    CONTROL: 'f1b38852-8da2-4445-b059-b04cad39ea13'
  }
};
export const getSalesAdviceGeneratedProductContentVariationId = () => {
  return salesAdviceGeneratedProductContentVariationIds[
    process.env.ENVIRONMENT || Environment.TESTING
  ];
};

export enum PreCartPresentationShowProsAndConsDirectlyOnPage {
  CONTROL = '290200dd-792c-4e90-b616-62d68be1546f',
  VARIATION_B = 'bc9f5c74-b789-4e15-be38-24688037f9f4'
}

export enum PreCartPresentationSteerCustomerToBetterProductFromCons {
  CONTROL = '48eb7cd1-04c0-40de-925f-21feb57c02c4',
  LINK_IN_CONS = '8b85149e-d7a6-4149-8d9d-985407fc61a6',
  LINK_IN_CONS_AND_REMOVE_OVERARCHING = '5616c078-e818-42b9-afc9-c6df6d323c76'
}

export enum PreCartPresentationShowConditionOfSecondChanceProductBelowProductTitle {
  CONTROL = 'ead0190c-caac-40bf-9147-79bd60d80c63',
  OFF = 'd7dba228-1aec-4ed0-814d-f0f70a82031c'
}

export enum PreCartPresentationConfigureAndSelectStoreStockElementPDP {
  CONTROL = '88ab405b-da42-4429-b1c1-62fff4bb47b4',
  HIDE_BUTTON = '7d02034c-3efc-46a3-ae1e-9c7098bc7329',
  HIDE_LINK = '41244622-82f0-4a18-acfd-54d109c345aa',
  HIDE_LINK_AND_RENAME_BUTTON = '2c329597-2f20-41c6-9816-2bc7cda6548b'
}

export enum CNSWriteAReviewMF {
  CONTROL = '6ea90490-f10b-4064-8677-617bc5a5420c',
  MICROFRONTEND = 'bcd6279e-0255-4b6e-90b7-23a60a7cc7e9'
}

export enum CSCAddChargerToOrderFromPDP {
  CONTROL = '2b791799-5b89-4b5b-a2a5-56fc511aeb03',
  VARIATION_B = '07095723-d0b4-459c-b1f2-f784239c5140',
  VARIATION_C = 'd9d85349-3635-4c31-b652-5932af137680'
}

export const CSCAddChargerToOrderFromPDPCampaignId = '68880caf-e02b-4538-baca-3fc3e2673faa';

export enum CNSChangePickUpInStoreWordingForBlackFriday {
  CONTROL = 'ee4090ab-b879-4954-b0d8-a6af32bd8b59',
  BLACK_FRIDAY_WORDING = '73d40c13-298b-4bf3-b734-cbe2d80ce829'
}
